import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import ScaleLoader from "react-spinners/ScaleLoader"
import { ErrorObject, user } from "../../api"
import { CreateUserRequest, UpdateUserRequest } from "../../api/user.api"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { RootState } from "../../store"
import { loadGroups } from "../../store/group.store"
import { createUser, loadUsers, resetSuccess, updateUser } from "../../store/user.store"
import { loadWarehouses } from "../../store/warehouse.store"
// import UsersTable from "components/Users/UsersTable";
import Header from "../Layout/Header"
import AddUserModal from "./AddUserModal"
// import DateRangePickerCustom from "components/Common/DateRangePicker/DateRangePickerCustom";
import UsersTable from "./UsersTable"

const Users = () => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const { userInfo } = useAppSelector((state: RootState) => state.auth)
    const { users, loading, error, success } = useAppSelector((state: RootState) => state.users)
    const { groups } = useAppSelector((state: RootState) => state.groups)
    const { warehouses } = useAppSelector((state: RootState) => state.warehouses)
    const [userDetails, setUserDetails] = useState({} as Record<string, any>)
    const [show, setShow] = useState(false)
    const handleShow = () => setShow(true)
    const [errors, setErrors] = useState({} as Record<string, any>)
    useEffect(() => {
        dispatch(loadUsers({}))
        if (groups?.length === 0) {
            dispatch(loadGroups())
        }
        if (warehouses?.length === 0) {
            dispatch(loadWarehouses())
        }
    }, [])

    const findFormErrors = (customError?: Record<string, any>) => {
        let newErrors = {} as Record<string, any>
        if (!customError) {
            if (error?.payload && error?.payload?.length !== 0) {
                error?.payload?.forEach((e: ErrorObject) => (newErrors[e?.param?.split(".")[1]] = e.msg))
            } else if (error?.error && error?.error !== "") {
                newErrors["genericError"] = error.error
            }
        } else {
            newErrors[customError?.param] = customError?.msg
        }
        return newErrors
    }

    const handleSubmit = async (userDetails: Record<string, any>) => {
        if (userDetails?.id) {
            await dispatch(updateUser(userDetails as UpdateUserRequest))
        } else {
            await dispatch(createUser(userDetails as CreateUserRequest))
        }
    }

    const checkIdentityValidity = async (userIdentity: string, param: string) => {
        try {
            await user.validateUserIdentity(userIdentity)
        } catch (error: any) {
            const returnedErrors = await findFormErrors({
                msg: error?.response?.data?.data?.code,
                param
            })
            setErrors(returnedErrors)
        }
    }

    useEffect(() => {
        if (users.length === 0) {
            dispatch(loadUsers({}))
        }
    }, [])

    useEffect(() => {
        const returnedErrors = findFormErrors()
        setErrors(returnedErrors)
    }, [error?.error, error?.payload?.length])

    useEffect(() => {
        if (success) {
            dispatch(loadUsers({}))
            setShow(false)
            dispatch(resetSuccess())
        }
    }, [success])

    return (
        <>
            {(!error && loading) || !userInfo?.accessToken ? (
                <div className="loader row justify-content-center">
                    <ScaleLoader color="#15397F" width={4} height={40} />
                </div>
            ) : (
                <div className="users-container">
                    <Header
                        title={t("Users")}
                        records={users?.length}
                        data={users}
                        name="Users"
                        //buttonId="#usersExportButton"
                    >
                        <div className="mx-2">
                            {/*<DateRangePickerCustom setStartDate={setStartDate} setEndDate={setEndDate} />*/}
                        </div>
                    </Header>
                    <div className="row justify-content-end mx-1 mt-3">
                        <Button className="col-1" onClick={handleShow}>
                            {t("Add User")}
                        </Button>
                    </div>
                    <div className="row  d-flex">
                        <UsersTable
                            users={users}
                            userDetails={userDetails}
                            setUserDetails={setUserDetails}
                            setShow={setShow}
                        />
                    </div>

                    <AddUserModal
                        show={show}
                        loading={loading}
                        userDetails={userDetails}
                        setUserDetails={setUserDetails}
                        handleSubmit={handleSubmit}
                        checkIdentityValidity={checkIdentityValidity}
                        handleClose={() => {
                            setUserDetails({})
                            setShow(false)
                        }}
                        groups={groups}
                        warehouses={warehouses}
                        errors={errors}
                        setErrors={setErrors}
                    />
                </div>
            )}
        </>
    )
}

export default Users
